import React from 'react';

function CloseIcon() {

	return (
		<div className='btn--full-width__icon'>
			<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M9.16102 7.43934C8.57523 6.85355 7.62549 6.85355 7.0397 7.43934C6.45391 8.02513 6.45391 8.97487 7.0397 9.56066L13.6569 16.1779L6.43934 23.3954C5.85355 23.9812 5.85355 24.9309 6.43934 25.5167C7.02513 26.1025 7.97487 26.1025 8.56066 25.5167L15.7782 18.2992L22.596 25.117C23.1818 25.7028 24.1316 25.7028 24.7174 25.117C25.3032 24.5312 25.3032 23.5815 24.7174 22.9957L17.8995 16.1779L24.117 9.96038C24.7028 9.3746 24.7028 8.42485 24.117 7.83906C23.5312 7.25328 22.5815 7.25328 21.9957 7.83906L15.7782 14.0565L9.16102 7.43934Z" fill="currentColor"/>
			</svg>
		</div>
	);
}
export default CloseIcon;
